import { useMobile } from "@/hooks/useMedia";
import { useVersionCheck } from "@/hooks/useVersionCheck";
import { LoginModal } from "@/lib/auth/login-modal";
import { isAuthRoute } from "@/lib/auth/routes";
import { authStore } from "@/lib/auth/store";
import { cn } from "@/lib/utils";
import { localizeHref } from "@/paraglide/runtime";
import Web3Provider from "@/providers/Web3Provider";
import NiceModal from "@ebay/nice-modal-react";
import { Outlet, useLocation } from "@tanstack/react-router";
import { useStore } from "@tanstack/react-store";
import { ThemeProvider } from "next-themes";
import { useEffect } from "react";
import AdultModal from "../business/adultModal";
import DepositModal from "../business/depositModal";
import InviteModal from "../business/invite/Modal";
import PPModal from "../business/ppModal";
import { Header } from "./header";
import { Sidebar } from "./sidebar";

export function Layout() {
	const location = useLocation();
	const user = useStore(authStore, (s) => s.user);
	const isMobile = useMobile();
	useEffect(() => {
		// 检查当前路由是否需要登录
		if (isAuthRoute(localizeHref(location.pathname)) && !user) {
			NiceModal.show(LoginModal);
		}
	}, [location.pathname, user]);

	/**
	 * 检查版本更新
	 */
	useVersionCheck();

	return (
		<NiceModal.Provider>
			<ThemeProvider
				attribute="class"
				defaultTheme="light"
				disableTransitionOnChange
			>
				<Web3Provider>
					<div className="flex flex-col h-screen bg-background text-foreground">
						<Header />
						<div className="flex-1 h-0 flex">
							{!isMobile && <Sidebar />}
							<div
								id="content"
								className={cn(
									"flex-1 overflow-y-auto md:py-7 py-4 md:px-10",
									location.pathname.includes("edit/") && "py-0!",
								)}
							>
								<Outlet />
							</div>
						</div>
						<DepositModal />
						<InviteModal />
						<PPModal />
						<AdultModal />
					</div>
				</Web3Provider>
			</ThemeProvider>
		</NiceModal.Provider>
	);
}
